import React from 'react';
import InsightsCard from './InsightsCard';
import './InsightsDashboard.css';

const InsightsDashboard = () => {
  return (
    <div className="insights-grid">
      <InsightsCard
        title="Wildlife Threats"
        data={[
          { name: 'Bushfire', value: 14 },
          { name: 'Poaching', value: 30 },
          { name: 'Deforestation', value: 56 },
        ]}
        colors={['#F87171', '#FBBF24', '#22C55E']}
      />
      <InsightsCard
        title="Endangered Zones"
        data={[
          { name: 'Zone A', value: 16 },
          { name: 'Zone B', value: 5 },
          { name: 'Zone C', value: 21 },
          { name: 'Zone D', value: 12 },
          { name: 'Zone E', value: 23 },
          { name: 'Zone F', value: 23 },
        ]}
        colors={['#bbf7d0', '#86efac', '#4ade80', '#22c55e', '#16a34a', '#15803d']}
      />
      <InsightsCard
        title="Threat Detection"
        data={[
          { name: 'Heat Sensor', value: 24 },
          { name: 'Smoke Sensor', value: 22 },
          { name: 'Sound Sensor', value: 36 },
          { name: 'Motion Sensor', value: 18 },
        ]}
        colors={['#2DD4BF', '#38BDF8', '#0EA5E9', '#1E40AF']}
      />
      <InsightsCard
        title="Surveillance Tools"
        data={[
          { name: 'Drones', value: 24 },
          { name: 'Sensors', value: 37 },
          { name: 'Cameras', value: 39 },
        ]}
        colors={['#EF4444', '#FACC15', '#3B82F6']}
      />
    </div>
  );
};

export default InsightsDashboard;
